<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <div class="admin-add-products fullheight">
        <v-toolbar dark :color="'#9e9e9e'">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <h1
              class="header-tittle"
              :style="{ color: colorsGeneralSecondary }"
            >
              Cierre de caja (Z)
            </h1>
          </v-toolbar-title>
        </v-toolbar>

        <div class="admin-orders" v-if="zboxClosure">
          <v-list class="mx-3">
            <v-col cols="12">
              <v-row>
                <v-col cols="12" sm="2">
                  <b>APERTURA DE CAJA:</b>
                </v-col>
                <v-col cols="12" sm="4">
                  {{ this.dayFormatLLAndTime(zboxClosure.opened_on) }}
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="2">
                  <b>CIERRE DE CAJA:</b>
                </v-col>
                <v-col cols="12" sm="4">
                  {{ this.dayFormatLLAndTime(zboxClosure.closed_on) }}
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="2">
                  <b>EFECTIVO:</b>
                </v-col>
                <v-col cols="12" sm="4">
                  {{ this.formatPrice(zboxClosure.total_invoiced_in_cash) }}
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="2">
                  <b>TARJETA:</b>
                </v-col>
                <v-col cols="12" sm="4"
                  >{{
                    this.formatPrice(zboxClosure.total_invoiced_on_credit_card)
                  }}
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="2">
                  <b>DATÁFONO:</b>
                </v-col>
                <v-col cols="12" sm="4"
                  >{{
                    this.formatPrice(zboxClosure.total_invoiced_in_datafono)
                  }}
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="2">
                  <b>GOOGLE PAY:</b>
                </v-col>
                <v-col cols="12" sm="4"
                  >{{
                    this.formatPrice(zboxClosure.total_invoiced_in_google_pay)
                  }}
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="2">
                  <b>APPLE PAY:</b>
                </v-col>
                <v-col cols="12" sm="4"
                  >{{
                    this.formatPrice(zboxClosure.total_invoiced_in_apple_pay)
                  }}
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="2">
                  <b>BIZUM:</b>
                </v-col>
                <v-col cols="12" sm="4"
                  >{{ this.formatPrice(zboxClosure.total_invoiced_in_bizum) }}
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="2">
                  <b>TOTAL VENTA (I.V.A 10%):</b>
                </v-col>
                <v-col cols="12" sm="4"
                  >{{
                    this.formatPrice(
                      Number(zboxClosure.total_invoiced_in_cash) +
                        Number(zboxClosure.total_invoiced_on_credit_card) +
                        Number(zboxClosure.total_invoiced_in_datafono)
                    )
                  }}
                </v-col>
              </v-row>

              <v-row v-if="unPaidOrders && unPaidOrders.length > 0">
                <v-col cols="2">
                  <b> NOTAS:</b>
                </v-col>
                <v-col cols="4">
                  <ul style="padding: 0">
                    <li v-for="(order, id) in unPaidOrders" :key="`order${id}`">
                      En la mesa <b>{{ order.table }}</b> no han pagado
                      <b>{{ order.amount }} €</b>
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </v-col>

            <v-divider></v-divider>

            <v-col cols="12" v-if="zboxClosure && zboxClosure.cash_count">
              <v-row>
                <v-col cols="12">
                  <b>RECUENTO DE EFFECTIVO</b>
                </v-col>

                <v-col cols="6">
                  <v-row>
                    <v-col cols="6">
                      <v-row>
                        <v-col cols="12" sm="4" class="pt-0 pb-0">
                          <b>{{ this.formatPrice(500) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            disabled
                            name="fiveHundred"
                            v-model="zboxClosure.cash_count.fiveHundred"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="6">
                      <v-row>
                        <v-col cols="12" sm="4" class="pt-0 pb-0">
                          <b>{{ this.formatPrice(200) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            disabled
                            name="twoHundred"
                            v-model="zboxClosure.cash_count.twoHundred"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6">
                      <v-row>
                        <v-col cols="12" sm="4" class="pt-0 pb-0">
                          <b>{{ this.formatPrice(100) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            disabled
                            name="oneHundred"
                            v-model="zboxClosure.cash_count.oneHundred"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="6">
                      <v-row>
                        <v-col cols="12" sm="4" class="pt-0 pb-0">
                          <b>{{ this.formatPrice(50) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            disabled
                            name="fifty"
                            v-model="zboxClosure.cash_count.fifty"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6">
                      <v-row>
                        <v-col cols="12" sm="4" class="pt-0 pb-0">
                          <b>{{ this.formatPrice(20) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="twenty"
                            disabled
                            v-model="zboxClosure.cash_count.twenty"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="6">
                      <v-row>
                        <v-col cols="12" sm="4" class="pt-0 pb-0">
                          <b>{{ this.formatPrice(10) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="ten"
                            disabled
                            v-model="zboxClosure.cash_count.ten"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6">
                      <v-row>
                        <v-col cols="12" sm="4" class="pt-0 pb-0">
                          <b>{{ this.formatPrice(5) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="five"
                            disabled
                            v-model="zboxClosure.cash_count.five"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="6">
                      <v-row>
                        <v-col cols="12" sm="4" class="pt-0 pb-0">
                          <b>{{ this.formatPrice(2) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="two"
                            disabled
                            v-model="zboxClosure.cash_count.two"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6">
                      <v-row>
                        <v-col cols="12" sm="4" class="pt-0 pb-0">
                          <b>{{ this.formatPrice(1) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="five"
                            disabled
                            v-model="zboxClosure.cash_count.one"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="6">
                      <v-row>
                        <v-col cols="12" sm="4" class="pt-0 pb-0">
                          <b>{{ this.formatPrice(0.5) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            disabled
                            name="pointFifty"
                            v-model="zboxClosure.cash_count.pointFifty"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6">
                      <v-row>
                        <v-col cols="12" sm="4" class="pt-0 pb-0">
                          <b>{{ this.formatPrice(0.2) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="pointTwenty"
                            disabled
                            v-model="zboxClosure.cash_count.pointTwenty"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="6">
                      <v-row>
                        <v-col cols="12" sm="4" class="pt-0 pb-0">
                          <b>{{ this.formatPrice(0.1) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="pointTen"
                            disabled
                            v-model="zboxClosure.cash_count.pointTen"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6">
                      <v-row>
                        <v-col cols="12" sm="4" class="pt-0 pb-0">
                          <b>{{ this.formatPrice(0.05) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="pointZeroFive"
                            disabled
                            v-model="zboxClosure.cash_count.pointZeroFive"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="6">
                      <v-row>
                        <v-col cols="12" sm="4" class="pt-0 pb-0">
                          <b>{{ this.formatPrice(0.02) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="pointZeroTwo"
                            disabled
                            v-model="zboxClosure.cash_count.pointZeroTwo"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6">
                      <v-row>
                        <v-col cols="12" sm="4" class="pt-0 pb-0">
                          <b>{{ this.formatPrice(0.01) }} :</b>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                          <v-text-field
                            style="padding-top: 0"
                            type="number"
                            name="pointZeroOne"
                            disabled
                            v-model="zboxClosure.cash_count.pointZeroOne"
                            required
                            placeholder="Introduce una cantidad"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" v-if="zboxClosure.total_cash_count">
              <v-row>
                <v-col cols="12" sm="2" class="pt-0 pb-0">
                  <b>TOTAL DEL RECUENTO:</b>
                </v-col>
                <v-col cols="12" sm="4" class="pt-0 pb-0">
                  {{ this.formatPrice(zboxClosure.total_cash_count) }}
                </v-col>
              </v-row>
            </v-col>

            <!-------------- DESCUADRE ----------------->
            <v-col cols="12" v-if="zboxClosure.cash_mismatch">
              <v-row>
                <v-col cols="12" sm="2" class="pt-0 pb-0">
                  <b>DESCUADRE:</b>
                </v-col>
                <v-col cols="12" sm="4" class="pt-0 pb-0">
                  {{ this.formatPrice(zboxClosure.cash_mismatch) }}
                </v-col>
              </v-row>
            </v-col>

            <v-divider></v-divider>

            <!----------------------  change -------------------------------->
            <v-col cols="6" v-if="zboxClosure && zboxClosure.change_count">
              <v-row>
                <v-col cols="12">
                  <b>CAMBIO PARA EL SIGUIENTE CIERRE DE CAJA</b>
                </v-col>

                <v-col cols="6">
                  <v-row>
                    <v-col cols="12" sm="4" class="pt-0 pb-0">
                      <b>{{ this.formatPrice(50) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        name="changeCountFifty"
                        disabled
                        v-model="zboxClosure.change_count.fifty"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <v-row>
                    <v-col cols="12" sm="4" class="pt-0 pb-0">
                      <b>{{ this.formatPrice(20) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        disabled
                        name="ctwenty"
                        v-model="zboxClosure.change_count.twenty"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6">
                  <v-row>
                    <v-col cols="12" sm="4" class="pt-0 pb-0">
                      <b>{{ this.formatPrice(10) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        disabled
                        name="changeCountTen"
                        v-model="zboxClosure.change_count.ten"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <v-row>
                    <v-col cols="12" sm="4" class="pt-0 pb-0">
                      <b>{{ this.formatPrice(5) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        disabled
                        name="cFive"
                        v-model="zboxClosure.change_count.five"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6">
                  <v-row>
                    <v-col cols="12" sm="4" class="pt-0 pb-0">
                      <b>{{ this.formatPrice(2) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        disabled
                        name="changeCountTwo"
                        v-model="zboxClosure.change_count.two"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <v-row>
                    <v-col cols="12" sm="4" class="pt-0 pb-0">
                      <b>{{ this.formatPrice(1) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        name="cOne"
                        disabled
                        v-model="zboxClosure.change_count.one"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6">
                  <v-row>
                    <v-col cols="12" sm="4" class="pt-0 pb-0">
                      <b>{{ this.formatPrice(0.5) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        name="changepointFifty"
                        disabled
                        v-model="zboxClosure.change_count.pointFifty"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <v-row>
                    <v-col cols="12" sm="4" class="pt-0 pb-0">
                      <b>{{ this.formatPrice(0.2) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        name="cpointTwenty"
                        disabled
                        v-model="zboxClosure.change_count.pointTwenty"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6">
                  <v-row>
                    <v-col cols="12" sm="4" class="pt-0 pb-0">
                      <b>{{ this.formatPrice(0.1) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        name="changepointTen"
                        disabled
                        v-model="zboxClosure.change_count.pointTen"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <v-row>
                    <v-col cols="12" sm="4" class="pt-0 pb-0">
                      <b>{{ this.formatPrice(0.05) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        disabled
                        name="cpointZeroFive"
                        v-model="zboxClosure.change_count.pointZeroFive"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6">
                  <v-row>
                    <v-col cols="12" sm="4" class="pt-0 pb-0">
                      <b>{{ this.formatPrice(0.02) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        name="cpointZeroTwo"
                        disabled
                        v-model="zboxClosure.change_count.pointZeroTwo"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <v-row>
                    <v-col cols="12" sm="4" class="pt-0 pb-0">
                      <b>{{ this.formatPrice(0.01) }} :</b>
                    </v-col>
                    <v-col cols="8" class="pt-0 pb-0">
                      <v-text-field
                        style="padding-top: 0"
                        type="number"
                        name="cpointZeroOne"
                        disabled
                        v-model="zboxClosure.change_count.pointZeroOne"
                        required
                        placeholder="Introduce una cantidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" v-if="zboxClosure.total_change_count">
              <v-row>
                <v-col cols="12" sm="2" class="pt-0 pb-0">
                  <b>CAMBIO TOTAL:</b>
                </v-col>
                <v-col cols="12" sm="4" class="pt-0 pb-0"
                  >{{ this.formatPrice(zboxClosure.total_change_count) }}
                </v-col>
              </v-row>
            </v-col>
          </v-list>
        </div>
        <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import { getZclousureById } from "@/collections/zClousures";
import Loader from "@/components/common/Loader";

export default {
  name: "ZboxClouserView",
  components: { Loader },
  data: () => ({
    dialog: false,
    zboxClosure: null,
    unPaidOrders: [],
    dialogLoader: false
  }),
  methods: {
    async open(data, unPaidOrders) {
      setTimeout(() => {
        this.unPaidOrders = unPaidOrders;
      }, 500);

      let self = this;

      this.dialogLoader = true;

      getZclousureById(data.id)
        .then(zClousure => {
          self.zboxClosure = zClousure;
          this.dialogLoader = false;
        })
        .catch(error => {
          this.setlogError(
            "get_zClousure_by_id",
            "Obtained error message in open()",
            error.stack,
            this.$options.name
          );
          this.dialogLoader = false;
        });

      this.dialog = true;
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>
<style scoped lang="scss">
.admin-add-products {
  height: 100vh;
  position: fixed;
  overflow-y: auto;
}
</style>
